import {ContentSubmissionKind} from './types';

const MB = 1024 * 1024;
const GB = 1024 * MB;
const PHOTO = ['image/gif', 'image/jpeg', 'image/png'];
const VIDEO = [
  'video/quicktime',
  'video/mp4',
  'video/x-m4v',
  'video/x-ms-wmv',
  'video/mpeg',
  'video/mpg',
  'video/x-msvideo',
  'video/avi',
  'video/x-flv',
  'video/webm',
];

// Allowed MIME types per deliverable kind, mirroring Ember's content-submission-form _kindAttributes.
const ALLOWED_TYPES: Record<ContentSubmissionKind, string[]> = {
  photo: PHOTO,
  video: VIDEO,
  blog: [...PHOTO, 'application/pdf'],
  mixed_media: [...PHOTO, ...VIDEO],
};

type Result = {valid: true} | {valid: false; reason: string};

export default function validateFile(
  file: File,
  kind: ContentSubmissionKind
): Result {
  if (!ALLOWED_TYPES[kind].includes(file.type)) {
    return {
      valid: false,
      reason: 'Unsupported file type for this deliverable.',
    };
  }
  if (VIDEO.includes(file.type)) {
    return file.size <= 3 * GB
      ? {valid: true}
      : {valid: false, reason: 'Videos must be 3GB or smaller.'};
  }
  return file.size <= 30 * MB
    ? {valid: true}
    : {valid: false, reason: 'Files must be 30MB or smaller.'};
}
